import { MutableRefObject } from 'react'
import ImageSkeleton from '../Skeleton/ImageSkeleton'
import { HeroImage } from '../../helpers/strapiMedia'

interface HeroCarouselProps {
  images: HeroImage[]
  loading: boolean
  activeSlide: number
  goToSlide: (index: number) => void
  trackRef: MutableRefObject<HTMLDivElement | null>
  slideRefs: MutableRefObject<Array<HTMLDivElement | null>>
  carouselAriaLabel: string
  trackAriaLabel: string
  dotsAriaLabel: string
}

const HeroCarousel = ({
  images,
  loading,
  activeSlide,
  goToSlide,
  trackRef,
  slideRefs,
  carouselAriaLabel,
  trackAriaLabel,
  dotsAriaLabel
}: HeroCarouselProps) => {
  return (
    <>
      <div id="hero-carousel" aria-label={carouselAriaLabel}>
        {loading ? (
          <ImageSkeleton className="home-hero-skeleton" />
        ) : (
          <div ref={trackRef} className="hero-track" aria-label={trackAriaLabel}>
            {images.map((image, index) => (
              <div
                key={`${image.src}-${index}`}
                ref={(element) => { slideRefs.current[index] = element }}
                className="hero-slide"
              >
                <img src={image.src} alt={image.alt} draggable={false} />
              </div>
            ))}
          </div>
        )}

        <button className="carousel-btn prev" type="button" aria-label="Anterior" onClick={() => goToSlide(activeSlide - 1)}>
          <svg className="flickity-button-icon" viewBox="0 0 100 100" aria-hidden="true">
            <path d="M64.3 10.7L58.6 5 13.6 50l45 45 5.7-5.7L24.9 50z" />
          </svg>
        </button>
        <button className="carousel-btn next" type="button" aria-label="Siguiente" onClick={() => goToSlide(activeSlide + 1)}>
          <svg className="flickity-button-icon" viewBox="0 0 100 100" aria-hidden="true">
            <path d="M35.7 89.3L41.4 95l45-45-45-45-5.7 5.7L75.1 50z" />
          </svg>
        </button>
      </div>

      {!loading && (
        <div className="carousel-dots flickity-page-dots z-9999" aria-label={dotsAriaLabel}>
          {images.map((image, index) => (
            <button
              key={`${image.src}-dot-${index}`}
              className={`dot ${activeSlide === index ? 'is-selected' : ''}`}
              type="button"
              aria-label={`Ir a imagen ${index + 1}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default HeroCarousel
